module.exports = __webpack_public_path__ + "img/jquery.03edd426.png";